export const GARBAGES = 'garbages'
